import { render } from "./OrganizationChartNode.vue?vue&type=template&id=2b8c62d0"
import script from "./OrganizationChartNode.vue?vue&type=script&lang=js"
export * from "./OrganizationChartNode.vue?vue&type=script&lang=js"

import "./OrganizationChartNode.vue?vue&type=style&index=0&id=2b8c62d0&lang=css"

import exportComponent from "/Users/augustin/Documents/DEV/vue3-organization-chart/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__